/**
 * Service: rulesEngineApi
 */
angular.module('acme.common.service.rulesEngineApi', [
  'acme.common.factory.QueryStringBuilder',
  'acme.common.factory.apiVersion'
])
.service('RulesEngineApiService', [ '$http', 'QueryStringBuilderFactory', 'ApiVersionFactory', function($http, QueryStringBuilderFactory, ApiVersionFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/ruleengine';
        this.lifecycle.service = this.service + '/lifecyclerules';
        this.rule.service = this.service + '/rule';
        this.rule.endpoint = endpoint;
      },

      lifecycle: {

        service: '',

        init: function () {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({ url: this.service + '/init/true', version: 'v2' })
          });
        },

        list: function () {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({ url: this.service, version: 'v2' })
          });
        }

      },

      rule: {

        service: '',
        endpoint: '',

        detail: function (props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({ url: this.service + 's/' + props.id, version: 'v2' })
          });
        },

        create: function (props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({ url: this.service + '/' + props.templateId, version: 'v2' })
          });
        },

        update: function (props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            headers: {
              'Content-Type': 'text/plain'
            },
            url: av.init({ url: this.endpoint + '/ruleengine/template/' + props.category.id + '/' + props.rule.section, version: 'v2' }),
            data: props.rule.selectedId
          });
        },

        updateTrigger: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({ url: this.service + '/' + props.id +'/trigger/params', version: 'v2' }),
            data: {
              startMonth: props.startMonth,
              endMonth: props.endMonth,
              monthsBeforeEnd: props.monthsBeforeEnd,
              expirationBased: props.expirationBased
            }
          });
        },

        remove: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({ url: this.endpoint + '/ruleengine/rules/' + props.id, version: 'v2' })
          });
        }

      }

    };

}]);